import * as React from "react"
import Footer from "../Footer"
import Header from "../Header"
import * as style from "./style.module.css"
import { useEffect } from 'react';

import Lenis from '@studio-freight/lenis';

const Layout = ({ children }) => {

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2, // スクロールの持続時間
      orientation: 'vertical', // 垂直スクロール
      gestureOrientation: 'vertical', // ジェスチャーの向き
      smooth: true, // スムーズスクロールを有効に
    });

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);
  
  return (
    <>
      <Header />
      <main className={style.main}>{children}</main>
      <Footer />
    </>
  )
}

export default Layout
